import React from "react";
import {
  Button,
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../../components/Global/OrderColumn";
import useShop from "./useShop";
import AddShop from "./AddShop";
import { Table } from "../../Global/Table";
import Filter from "./Filter";
import FilterButton from "../../Global/FilterButton";
const Shop = () => {
  const {
    queryState,
    showEditModal,
    tableFields,
    queryList,
    isLoading,
    isFetching,
    paginationOptions,
    getRow,
    handleEditColumnsClick,
    handleSort,
    handlePagination,
    handleModalClick,
    handleDelete,
    handleDeleteModal,
    handleEditAction,
    handleSearch,
    updateShopFields,
    handleClearClick,
    handlePageSize,
    handleFilterClick,
    filterCount,
    handleExport,
    isExporting,
    refetch,
  } = useShop();
  return (
    <div>
      <HeadingGroup
        title={"Supplier or Shop"}
        className={`pro-mb-4`}
        buttonTitle={queryList?.data?.create_permission && "Add new"}
        handleClick={handleModalClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className="row gx-2 gy-2 flex-fill">
          <div className={`col-auto`}>
            <div className="search-wrap xl">
              <SearchFilters
                onSearchInput={handleSearch}
                showActions={true}
                handleActionClick={handleEditColumnsClick}
                loading={isLoading}
                SearchIcon={
                  <span className="material-symbols-outlined"> search </span>
                }
                searchInputProps={{
                  value: queryState?.search,
                  placeholder:
                    " Search Name, Location, Contact Number, Email, GST Number",
                }}
              />
            </div>
          </div>
          <div className={`col-auto`}>
            <button
              className={`pro-btn pro-items-center pro-btn-outline pro-h-100 ${
                isExporting ? "loading" : ""
              }`}
              onClick={handleExport}
              disabled={isExporting}
            >
              <span className="material-symbols-outlined">download</span>
              <span>Export</span>
            </button>
          </div>
          <div className={`col-auto`}>
            <FilterButton
              onClick={handleFilterClick}
              filterCount={filterCount}
              label="Filters"
            />
          </div>
          <div className={`col-auto`}>
            <Button
              className={"pro-btn-link lg pro-px-5"}
              onClick={handleClearClick}
            >
              Clear
            </Button>
          </div>
        </div>
        <Table
          multiSelect={false}
          data={queryList?.data?.data || []}
          uniqueID={"_id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          editIcon={<span className="material-symbols-outlined">edit</span>}
          deleteIcon={<span className="material-symbols-outlined">delete</span>}
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          clear={queryState.clearSelection}
          perpage={queryState?.currentPageSize}
          assignable={false}
          handleEdit={handleEditAction}
          handleDelete={handleDeleteModal}
          deletable={queryList?.data?.delete_permission}
          editable={queryList?.data?.edit_permission}
          showCheckBox={true}
        />
        {queryList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={queryState?.currentPage}
            totalPageCount={Math.ceil(
              queryList.data.total_count / queryState.currentPageSize,
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={queryState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure delete the selected item ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={queryList?.data?.fields}
              moduleId={queryList?.data?.module_id}
              updateData={updateShopFields}
            />
          </div>
        </ModalLayout>

        <OffCanvasLayout
          show={queryState?.showAddShopModal}
          handleClose={handleModalClick}
          title={
            queryState?.isEdit ? "Update Shop/Supplier" : "Add Shop/Supplier"
          }
          closeIcon={<span className="material-symbols-outlined"> close </span>}
        >
          <AddShop refetch={refetch} />
        </OffCanvasLayout>

        <OffCanvasLayout
          show={queryState?.showFilter}
          handleClose={handleFilterClick}
          title={"Filter"}
          closeIcon={<span className="material-symbols-outlined"> close </span>}
        >
          <Filter />
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default Shop;
